<template lang="pug">
  e-modal(
    @close="onClose"
    @confirm="saveOptimalRoute"
    title="Построить оптимальный маршрут"
    :autoHeight="true"
  )
    slot
    .form-group
      label.form-group__label.semibold.label Введите адрес начальной точки *
      e-address(
        :model="fields"
        name="address"
        @selectItem="onSelectFirstPoint"
      )
    search-object(
      v-for="(point, index) in points"
      :key="'garbage' + index"
      :index="index"
      endpoint="garbage"
      :title="'Контрольная точка №' + Number(index + 1)"
      @selectItem='(data) => onSelectPoint(data, point)'
    )
    button.reset-btn.button.button_usual(@click='addPoint' style="margin-bottom: 10px") Добавить
    search-object(
      endpoint="tko"
      title='Место размещения отходов *'
      @selectItem='onSelectLastPoint'
    )
</template>
<script>
import SearchObject from './SearchObject'
export default {
  name: 'OptimalModal',
  components: { SearchObject },
  data() {
    return {
      fields: {
        address: '',
      },
      query: '',
      firstPoint: null,
      lastPoint: null,
      points: [{ id: 1 }],
    }
  },
  methods: {
    addPoint() {
      this.points.push({ id: this.points.length + 1 })
    },
    saveOptimalRoute() {
      if (
        !this.firstPoint ||
        !this.lastPoint ||
        this.points.some((item) => item.id)
      ) {
        this.$notify.error({
          title: `Пожалуйста заполните данные`,
        })
        return
      }
      const waypoints = [this.firstPoint, ...this.points, this.lastPoint]
      this.$emit('saveOptimalRoute', waypoints)
    },
    onClose() {
      this.$emit('close')
    },
    onSelectFirstPoint(data) {
      if (data.data.geo_lat && data.data.geo_lon) {
        this.firstPoint = [data.data.geo_lat, data.data.geo_lon]
      }
    },
    onSelectPoint(data, point) {
      const pointIndex = this.points.findIndex((item) => item.id === point.id)

      if (pointIndex >= 0) {
        if (data.every((item) => item)) {
          this.points.splice(pointIndex, 1, data)
        }
      } else {
        this.points.push(data)
      }
    },
    onSelectLastPoint(data) {
      this.lastPoint = data
    },
  },
}
</script>
